/**
 * Square payroll sync (WP4-TIMECLOCK-SQUARE): Velora punches become Square
 * Labor timecards, and Square Payroll pays from them. Managers link staff
 * and offices, watch per-entry sync on the timesheet, resolve conflicts and
 * check the pay period here. Query keys start with `timeclock_square`.
 */
import { defineManifest } from '@velora/contracts';
import {
  SQUARE_PAYROLL_PERMISSIONS,
  TIMECLOCK_SQUARE_ENTITY,
} from '@velora/contracts/timeclock-square';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'timeclock-square',
    title: 'Square payroll',
    version: '0.1.0',
    owner: 'WP4-TIMECLOCK-SQUARE',
    entitlementKey: null,
    permissions: [SQUARE_PAYROLL_PERMISSIONS.manage, SQUARE_PAYROLL_PERMISSIONS.connect],
    routes: [
      {
        id: 'square-payroll',
        path: '/timesheets/square',
        title: 'Square payroll',
        officeScope: 'location',
        permission: SQUARE_PAYROLL_PERMISSIONS.manage,
      },
    ],
    // No sidebar item: this page belongs to Timesheets (its header button) and the
    // command palette, so the navigation placement stays as it is.
    nav: [],
    commands: [
      {
        id: 'timeclock-square.open',
        title: 'Square payroll',
        keywords: ['square', 'payroll', 'timecards', 'overtime', 'pay period', 'team members'],
        routeId: 'square-payroll',
        permission: SQUARE_PAYROLL_PERMISSIONS.manage,
      },
    ],
    sseEntityKeys: [TIMECLOCK_SQUARE_ENTITY],
  }),
  pages: {
    'square-payroll': () => import('./SquarePayrollPage.js'),
  },
});
